import { getBaseURL, getClient } from 'BLL/clients/HttpClient';
import { ApiEndPoint } from 'BLL/Enums/ApiEndPoint';

export const getSignedUrl = async (
  docUrl: string,
  source: 'bill' | 'waiver' | 'medical-record'
): Promise<string> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });
  const { data } = await client.get<{ signedUrl: string }>(
    `v1/documents/signed-url`,
    {
      params: { docUrl, source },
    }
  );
  return data.signedUrl;
};
